import { DropdownMenu } from '@breezeventures/ui-kit/dropdown-menu';

import { MenuProps } from './types';

export const DesktopMenu = ({ trigger, items }: MenuProps) => (
  <DropdownMenu>
    <DropdownMenu.Trigger asChild>{trigger}</DropdownMenu.Trigger>

    <DropdownMenu.Content collisionPadding={16}>
      {items.map((item) => (
        <DropdownMenu.Item
          key={item.key}
          onClick={item.onClick}
          className="justify-normal"
        >
          <span className="size-5 shrink-0">{item.icon}</span>
          {item.label}
        </DropdownMenu.Item>
      ))}
    </DropdownMenu.Content>
  </DropdownMenu>
);
